import { func, object, oneOfType, string } from 'prop-types';
import React from 'react';
import { sendTrackingEvent } from '../../analytics/trackingEvent';
import { PrimaryButton } from '../mui/Button';

/**
 * TrackingButton - A reusable button component that sends tracking events when clicked
 *
 * This component wraps any button component (defaulting to PrimaryButton) and sends
 * tracking events when clicked while preserving all original button functionality.
 *
 * @param {string} eventName - Required name of the tracking event
 * @param {object} trackingData - Optional data to include with the tracking event
 * @param {React.Component} component - Optional custom button component to use
 * @param {*} buttonProps - All remaining props are passed to the button component
 */
const TrackingButton = ({
  eventName,
  trackingData = {},
  children,
  component: ButtonComponent = PrimaryButton,
  ...buttonProps
}) => {
  const handleClick = e => {
    // Capture tracking event with consistent format
    sendTrackingEvent({
      name: eventName,
      parameters: {
        ...trackingData,
      },
    });

    // Execute original onClick if present
    if (buttonProps.onClick) {
      buttonProps.onClick(e);
    }
  };

  return (
    <ButtonComponent {...buttonProps} onClick={handleClick}>
      {children}
    </ButtonComponent>
  );
};

TrackingButton.propTypes = {
  eventName: string.isRequired,
  trackingData: object,
  children: oneOfType([string, object, func]).isRequired,
  component: oneOfType([func, object]),
  onClick: func,
};

export default TrackingButton;
